import {
  CheckNotes,
  InspectionCase,
  InspectionWaterSupplyDataCase,
  InspectionWaterSupplyDataCaseDto
} from '../../inspection-cases';
import {
  InspectionPumpCase,
  InspectionPumpCaseDto
} from '../../inspection-cases/inspection-pump-case.dto';

export class FireExtinguishingPumpsInstallationDto extends InspectionCase {
  waterSupplySource?: InspectionCase;
  pumpPowerSupply?: InspectionCase;
  pumpDetails?: InspectionPumpCaseDto;
  commandPanelModel?: InspectionCase;
  equipmentInstalledAccordingSpec?: InspectionCase;
  airVents?: InspectionCase;
  liquidity?: InspectionCase;
  emergencyLighting?: InspectionCase;
  floodDetection?: InspectionCase;
  jockeyPumpInPressure?: InspectionWaterSupplyDataCaseDto;
  jockeyPumpOutPressure?: InspectionWaterSupplyDataCaseDto;
  dieselOrElectricPumpInPressure?: InspectionWaterSupplyDataCaseDto;
  dieselOrElectricPumpOutPressure?: InspectionWaterSupplyDataCaseDto;
}

export class FireExtinguishingPumpsInstallation extends FireExtinguishingPumpsInstallationDto {
  constructor(
    data: FireExtinguishingPumpsInstallationDto = {
      title: 'התקנת משאבה/ות כיבוי אש'
    }
  ) {
    super(data);
    this.waterSupplySource = new InspectionCase({
      ...data.waterSupplySource,
      title: `ציין מהוא מקור אספקת המים למשאבה/ות (מאגר מים, רשת עירונית וכד')`
    });
    this.pumpPowerSupply = new InspectionCase({
      ...data.pumpPowerSupply,
      title: `ציין אספקת חשמל למשאבה/ות ,ארצית או אחר`
    });
    this.pumpDetails = new InspectionPumpCase({
      ...data.pumpDetails,
      title: 'פרטי משאבה'
    });
    this.commandPanelModel = new InspectionCase({
      ...data.commandPanelModel,
      title: `במידה וקיים לוח מעבר לגנרטור חירום ציין את דגם לוח הפיקוד`
    });
    this.equipmentInstalledAccordingSpec = new InspectionCase({
      ...data.equipmentInstalledAccordingSpec,
      title: `התקנת צנרת יניקה, סניקה, מגופים, אביזרים, מד ספיקה ,שעוני לחץ וקווי פיקוד הותקנו בהתאם לדרישות התקן והתכנון`
    });
    this.airVents = new InspectionCase({
      ...data.airVents,
      title: `כל פתחי האיורור חופשים`
    });
    this.liquidity = new InspectionCase({
      ...data.liquidity,
      title: `אין נזילות בצנרת ובמחברים`
    });
    this.emergencyLighting = new InspectionCase({
      ...data.emergencyLighting,
      title: `הותקנה תאורת חירום בחדר`
    });
    this.floodDetection = new InspectionCase({
      ...data.floodDetection,
      title: `בחדר משאבות בקומה שלילית האם הותקנו אמצעי גילוי להצפה`
    });
    this.jockeyPumpInPressure = new InspectionWaterSupplyDataCase({
      ...data.jockeyPumpInPressure,
      title: `לחץ כניסה מכוון של משאבת הג'וקי (psi)`,
      notes:
        data.notes && data.jockeyPumpInPressure.notes.length > 0
          ? data.jockeyPumpInPressure.notes
          : [
              {
                addNotesToReport: true,
                notes: `לחץ כניסה מכוון של משאבת הג'וקי: 0psi`
              }
            ]
    });
    this.jockeyPumpOutPressure = new InspectionWaterSupplyDataCase({
      ...data.jockeyPumpOutPressure,
      title: `לחץ יציאה מכוון של משאבת הג'וקי (psi)`,
      notes:
        data.notes && data.jockeyPumpOutPressure.notes.length > 0
          ? data.jockeyPumpOutPressure.notes
          : [
              {
                addNotesToReport: true,
                notes: `לחץ יציאה מכוון של משאבת הג'וקי: 0psi`
              }
            ]
    });
    this.dieselOrElectricPumpInPressure = new InspectionWaterSupplyDataCase({
      ...data.dieselOrElectricPumpInPressure,
      title: `לחץ כניסה מכוון של משאבת הכיבוי, דיזל או חשמלית (psi)`,
      notes:
        data.notes && data.dieselOrElectricPumpInPressure.notes.length > 0
          ? data.dieselOrElectricPumpInPressure.notes
          : [
              {
                addNotesToReport: true,
                notes: `לחץ כניסה מכוון של משאבת הכיבוי, דיזל או חשמלית: 0psi`
              }
            ]
    });
    this.dieselOrElectricPumpOutPressure = new InspectionWaterSupplyDataCase({
      ...data.dieselOrElectricPumpOutPressure,
      title: `לחץ יציאה מכוון של משאבת הכיבוי דיזל או חשמלית (psi)`,
      notes:
        data.notes && data.dieselOrElectricPumpOutPressure.notes.length > 0
          ? data.dieselOrElectricPumpOutPressure.notes
          : [
              {
                addNotesToReport: true,
                notes: `לחץ יציאה מכוון של משאבת הכיבוי, דיזל או חשמלית: 0psi`
              }
            ]
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.waterSupplySource.isApplicable ||
        this.waterSupplySource.isPassed) &&
        (!this.pumpPowerSupply.isApplicable || this.pumpPowerSupply.isPassed) &&
        (!this.pumpDetails.isApplicable || this.pumpDetails.isPassed) &&
        (!this.commandPanelModel.isApplicable ||
          this.commandPanelModel.isPassed) &&
        (!this.equipmentInstalledAccordingSpec.isApplicable ||
          this.equipmentInstalledAccordingSpec.isPassed) &&
        (!this.airVents.isApplicable || this.airVents.isPassed) &&
        (!this.liquidity.isApplicable || this.liquidity.isPassed) &&
        (!this.emergencyLighting.isApplicable ||
          this.emergencyLighting.isPassed) &&
        (!this.floodDetection.isApplicable || this.floodDetection.isPassed) &&
        (!this.jockeyPumpInPressure.isApplicable ||
          this.jockeyPumpInPressure.isPassed) &&
        (!this.jockeyPumpOutPressure.isApplicable ||
          this.jockeyPumpOutPressure.isPassed) &&
        (!this.dieselOrElectricPumpInPressure.isApplicable ||
          this.dieselOrElectricPumpInPressure.isPassed) &&
        (!this.dieselOrElectricPumpOutPressure.isApplicable ||
          this.dieselOrElectricPumpOutPressure.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.waterSupplySource.getNotes(),
      ...this.pumpPowerSupply.getNotes(),
      ...this.pumpDetails.getNotes(),
      ...this.commandPanelModel.getNotes(),
      ...this.equipmentInstalledAccordingSpec.getNotes(),
      ...this.airVents.getNotes(),
      ...this.liquidity.getNotes(),
      ...this.emergencyLighting.getNotes(),
      ...this.floodDetection.getNotes(),
      ...this.jockeyPumpInPressure.getNotes(),
      ...this.jockeyPumpOutPressure.getNotes(),
      ...this.dieselOrElectricPumpInPressure.getNotes(),
      ...this.dieselOrElectricPumpOutPressure.getNotes()
    ];
  }
}
